import { all } from 'redux-saga/effects';
import auth from './auth/sagas';
import propostas from './propostas/sagas';

export default function* rootSaga() {
  return yield all([auth, propostas]);
}
